import PolicyDetailFire from './PolicyDetailFire';
export default PolicyDetailFire;
